module.exports = __webpack_public_path__ + "img/buyTxt.fa92c4c0.png";